module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-2.c024a3f7.jpg";